import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import AttendanceAudits from './components/attendanceAudits/AttendanceAudits';

const AuditManagement = () => {
  return renderComponent(<AttendanceAudits />);
};

export default AuditManagement;
